module.exports = __webpack_public_path__ + "static/img/1-pptg.1a3311d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/app/1-pptg.png
// module id = RiVC
// module chunks = 1